import placeholder from "./assets/images/placeholder.jpg";

const navMenuItems = (managedProviders) => {
  let menus = [
    {
      name: "فروشگاه",
      url: "/order/list",
      icon: "ShoppingCartIcon",
    },
    {
      name: "افزودن سفارش",
      url: "/order/create",
      icon: "PlusIcon",
    },
    {
      url: "/products",
      name: "ایجاد فروشگاه",
      icon: "ShoppingBagIcon",
    },
    {
      url: "/shop-settings",
      name: "تنظیمات فروشگاه",
      icon: "SettingsIcon",
    },
    {
      url: "/provider-profile",
      name: "پروفایل مجموعه",
      icon: "UserIcon",
    },
    {
      url: "/customer-club",
      name: "باشگاه مشتریان",
      icon: "UsersIcon",
    },
    {
      url: "/provider-employees",
      name: "کارمندان",
      icon: "UsersIcon",
    },
    {
      url: "/provider-package",
      name: "اطلاعات بسته",
      icon: "InfoIcon",
    },
    {
      url: "/delivery",
      name: "محدوده پیک",
      icon: "TruckIcon",
    },
    {
      url: "/coupons",
      name: "جشنواره تخفیف",
      icon: "PercentIcon",
    },
    {
      url: "/tickets",
      name: "تیکت ها",
      icon: "FileTextIcon",
    },
    {
      url: "/tables",
      name: "مدیریت میزها",
      icon: "LayoutIcon",
    },
  ];

  if (managedProviders.length > 1) {
    menus.splice(0, 0, {
      id: "providers",
      url: null,
      name: "مدیریت مجموعه ها",
      icon: "PackageIcon",
      submenu: managedProviders.map((provider) => ({
        url: `/select-provider/${provider.id}`,
        name: provider.name ?? provider.persian_name ?? provider.english_name,
        persianName: provider.persian_name,
        englishName: provider.english_name,
        slug: provider.name,
        image: (provider.logo && provider.logo.url) || placeholder,
      })),
    });
  }

  return menus;
};

export default navMenuItems;
